import { useQuery } from '@tanstack/react-query';

import { getTopup, type TopupContent } from '@/services/topup';

export type { TopupContent };

// The studio's singleton top-up. A slug unlocks a PRIVATE top-up's direct-link
// page; slug-less only resolves a PUBLIC one.
export default function useTopup({
  enabled = true,
  slug,
}: { enabled?: boolean; slug?: string } = {}) {
  return useQuery({
    queryKey: ['topup-content', slug ?? null],
    queryFn: () => getTopup(slug),
    enabled,
  });
}
